import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
  showSidebar,
} from '../../store/layout/actions';
import { isMobileViewport } from '../../helpers/sharedFunction';

// Layout Related Components
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

const capitalizeFirstLetter = (string) => {
  return string.charAt(1).toUpperCase() + string.slice(2);
};

const Layout = ({ children }) => {
  const {
    layoutWidth,
    leftSideBarTheme,
    leftSideBarType,
    topbarTheme,
    showSidebar: mobileMenuOpen,
  } = useSelector((state) => state.Layout);
  const [isMobile, setIsMobile] = useState(isMobileViewport);

  const location = useLocation();
  const { pathname } = location;
  const dispatch = useDispatch();

  useEffect(() => {
    // Scroll Top to 0
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    document.title = capitalizeFirstLetter(pathname) + ' | Chiedimi.it - CRM';
  }, [pathname]);

  useEffect(() => {
    if (leftSideBarTheme) dispatch(changeSidebarTheme(leftSideBarTheme));
    if (layoutWidth) dispatch(changeLayoutWidth(layoutWidth));
    if (topbarTheme) dispatch(changeTopbarTheme(topbarTheme));
  }, [leftSideBarTheme, layoutWidth, topbarTheme, dispatch]);

  useEffect(() => {
    const handleResize = () => setIsMobile(isMobileViewport());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // leftSideBarType is the desktop expanded/collapsed preference; the mobile
  // menu is an overlay instead, opened by showSidebar and always closed at
  // start. Applied on mount and across the breakpoint only: the Header
  // applies the toggles it makes itself.
  useEffect(() => {
    if (leftSideBarType) dispatch(changeSidebarType(leftSideBarType, isMobile));
    if (isMobile) dispatch(showSidebar(false));
  }, [isMobile]); // eslint-disable-line react-hooks/exhaustive-deps

  // The mobile menu covers the page the user just picked from it. Picking the
  // page already open replaces the location without changing the pathname,
  // so this follows the whole location
  useEffect(() => {
    if (isMobileViewport()) dispatch(showSidebar(false));
  }, [location, dispatch]);

  // While the mobile menu is open a tap on the page only closes it
  const handleContentClickCapture = (event) => {
    if (!isMobile || !mobileMenuOpen) return;
    event.preventDefault();
    event.stopPropagation();
    dispatch(showSidebar(false));
  };

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Header />
        <Sidebar
          theme={leftSideBarTheme}
          type={leftSideBarType}
          isMobile={isMobile}
        />
        <div
          className="main-content"
          onClickCapture={handleContentClickCapture}
        >
          {children}
        </div>
        <Footer />
      </div>
    </React.Fragment>
  );
};

export default Layout;
